<template>
    <div class="flex">
        <div class="page-hero page-container padding">
            <h1>Our Integrations</h1>
            <hr>
            <div class="container-fluid bg-white row align-items-center">
                <div class="padding text-center d-flex flex-column align-items-center">
                    <img style="height:80px; width:200px"
                         src="https://static.hsappstatic.net/salesImages/static-1.398/logos/hubspot-standard.svg" 
                         alt="HubSpot CRM">
                    <a class="btn w-sm mt-1 btn-primary"
                       style="heigth:80px;"
                       target="_blank"
                       href="https://api.pragmapredict.com/hubspot/registerhubspot">
                        Connect
                    </a>
                </div>
                <div class="padding text-center">
                    <h5 >Try our HubSpot CRM extension!</h5>
                </div>
                
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'Integrations',
}
</script>



// WEBPACK FOOTER //
// src/components/Integrations.vue